import api from './api'
import app from './app'

export default { app, api }
